export default {
  'What is Nucleo?': 'Хто ми?',
};
